import { RouteConfig } from 'vue-router';
const Home = () => import('./home.vue');
const Assess = () => import('../access/access.vue');
const Setting = () => import('../setting/setting.vue');
const Siwei = () => import('../siwei/siwei.vue');
const Shixun = () => import('../shixun/shixu.vue');
const Teacher = () => import('../teacher/teacher.vue');
const Manage = () => import('../manage/manage.vue');
import AssessRouterChildren from '../access/access.router';
import SettingRouterChildren from '../setting/setting.router';
import SiweiRouterChildren from '../siwei/siwei.router';
import ShixunRouterChildren from '../shixun/shixun.router';
import TeacherRouterChildren from '../teacher/teacher.router';
import ManageRouterChildren from '../manage/manage.router';
const routers: RouteConfig[] = [
    {
        path: 'home',
        component: Home,
    },
    {
        path: 'assess',
        component: Assess,
        children: AssessRouterChildren
    },
    {
        path: 'setting',
        component: Setting,
        children: SettingRouterChildren
    },
    {
        path: 'siwei',
        component: Siwei,
        children: SiweiRouterChildren
    },
    {
        path: 'shixun',
        component: Shixun,
        children: ShixunRouterChildren
    },
    {
        path: 'teacher',
        component: Teacher,
        children: TeacherRouterChildren
    },
    {
        path: 'manage',
        component: Manage,
        children: ManageRouterChildren
    },
];
export default routers;

